var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-inline-block" }, [
    _vm.seeThroughObjects.length > 0
      ? _c(
          "div",
          { staticClass: "mt-2 see-through-container" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                ],
                staticClass: "w-100 mt-3",
                attrs: {
                  variant: "outline-primary",
                  size: "sm",
                  title: "Restore See-Through Objects",
                },
                on: {
                  click: function ($event) {
                    _vm.showRestoreModal = true
                  },
                },
              },
              [
                _c("i", { staticClass: "bi bi-arrow-counterclockwise" }),
                _vm._v("\n      Restore See-Through Objects\n      "),
                _c(
                  "b-badge",
                  { staticClass: "ml-1", attrs: { variant: "warning" } },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.seeThroughObjects.length) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  title: "Restore See-Through Objects",
                  "ok-title": "Restore All",
                },
                on: { ok: _vm.restoreAll },
                model: {
                  value: _vm.showRestoreModal,
                  callback: function ($$v) {
                    _vm.showRestoreModal = $$v
                  },
                  expression: "showRestoreModal",
                },
              },
              [
                _c(
                  "b-list-group",
                  _vm._l(_vm.seeThroughObjects, function (obj, index) {
                    return _c(
                      "b-list-group-item",
                      {
                        key: obj.id || obj.element_id || index,
                        staticClass:
                          "d-flex justify-content-between align-items-center",
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              obj.name ||
                                obj.id ||
                                obj.element_id ||
                                "Object " + (index + 1)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.restoreSingle(obj)
                              },
                            },
                          },
                          [_vm._v("\n            Restore\n          ")]
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }